import React from 'react';
import { Link } from 'react-router-dom';
import VERSIONS from '@assets/js/versions';
const appVersion = VERSIONS[process.env.REACT_APP_VERSION];

function Footer() {
  return (
    <footer className="container bg-muted rounded-lg shadow m-4 mt-auto mx-auto">
      <div className="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
        <div className="flex items-center justify-start gap-2">
          <Link to="/">
            <img
              className="hover:border-2 hover:rounded border-gray-300"
              src={appVersion.url}
              style={{ height: '38px', borderRadius: 10 }}
              alt="logo"
            />
          </Link>
          <span className="text-sm sm:text-center ">
            © 2025{' '}
            <Link to="/" className="hover:underline">
              {appVersion.brand === 'Edunexora' ? `${appVersion.brand} Eazy network solutions.` : `${appVersion.brand}`}
              ™
            </Link>
            . All Rights Reserved.
          </span>
        </div>

        <ul className="flex flex-wrap items-center mt-3 text-sm font-medium sm:mt-0">
          <li>
            <Link to="/privacy-policies" className="hover:underline me-4 md:me-6">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/terms-conditions" className="hover:underline me-4 md:me-6">
              Terms & Conditions
            </Link>
          </li>
          <li>
            <Link to={'/help'} className="hover:underline me-4 md:me-6">
              Contact
            </Link>
          </li>
          <li>
            <Link to={'/subscription'} className="hover:underline">
              Pricing
            </Link>
          </li>
          {/* <li>
            <Link to={'/return-refund'} className="hover:underline me-4 md:me-6">
              Return & Refund
            </Link>
          </li> */}
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
